import React from 'react'
import Layout from '../../components/Layout'
import Intro from './Intro'
import WhatWeDo from './WhatWeDo'
import WhychooseUs from './WhychooseUs'
import Footer from '../../components/Footer'

export const About = () => {
  return (
    <Layout>
      <Intro />
      <WhatWeDo />
      <WhychooseUs />
      <Footer/>
    </Layout>
  )
}
export default About